import CheckCircle from "components/inputs/checkBox/CheckCircle";
import InputText from "components/inputs/InputText";
import P from "components/P";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import {
  forwardRef,
  useContext,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import style from "./ShippingInfomation.module.css";
import NiceModal from "@ebay/nice-modal-react";
import { CFormSelect } from "@coreui/react";
import { useTransition } from "react";
import { useTranslation } from "react-i18next";
import { textFormat, mobileNoFormat } from "InitialData/regExp";
import { validateInputs } from "shared/utils/Utils";
import Select from "react-select";
import { storeRequester } from "App";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import Flex from "layouts/flex/Flex";
import CustomButton from "components/buttons/CustomButton";
import RadioGroup from "components/manager/views/forms/radio/RadioGroup";

import Radio from "components/inputs/radio/Radio";
import { toast } from "react-toastify";
import { Button } from "@mui/material";
import Dummy from "components/Dummy";
import MessageInput from "components/inputs/MessageInput";

const NewShippingInfomation = forwardRef((props, ref) => {
  const { width, isMobile } = useContext(BrowserDetectContext);

  const inputs = useRef([]);
  const [defaultShippingInfo, setDefaultShippingInfo] = useState();
  const [selectedShippingInfo, setSelectedShippingInfo] = useState();
  const [shippingInfo, setShippingInfo] = useState([]);
  const [checked, setChecked] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [type, setType] = useState("EXISTING");
  // const [message, setMessage] = useState('');
  const { t } = useTranslation();
  const {
    shippingAddress,
    setAdd,
    setSelectAddressId,
    setSelectAddress,
    selectAddressId,
    // messageRef,
    message,
    fetchCustomer,
    onMessageChange
  } = props;

  // const handleMessageChange = (value) => {
  //   setMessage(value);
  //   if (onMessageChange) {
  //     onMessageChange(value);
  //   }
  // };

  const shippingInfoClick = async () => {
    try {
      const updatedAddresses = await fetchCustomer();
      NiceModal.remove("shippingInfoSelectModal");
      NiceModal.show("shippingInfoSelectModal", {
        callback: shippingInfoCallback,
        shippingAddress: updatedAddresses,  // 최신 데이터 직접 전달
        setSelectedShippingInfo: setSelectedShippingInfo,
        selectAddressId: selectAddressId,
        setSelectAddressId: setSelectAddressId,
        setSelectAddress: setSelectAddress,
      });
    } catch (error) {
      console.error('Error fetching customer:', error);
    }
  };


  const shippingInfoCallback = (value, disabled, check) => {
    setTimeout(() => {
      setDisabled(disabled);
      setShippingInfo(value);
      setDefaultShippingInfo(value);
      setChecked(check || false);
    }, 100);
  };



  const onAddShippingInfoClick = () => {
    isMobile ? (
      NiceModal.show("shippingInfoAddKrModal", {
        callback: onShippingInfoModalClose,
        setAdd: setAdd,
      })
    )
      :

      NiceModal.show("shippingInfoAddModal", {
        callback: onShippingInfoModalClose,
        setIsAdd: setAdd,
      })
  };

  const onShippingInfoModalClose = (value) => {
    // setDefaultShippingInfo(value[0]);
    const lastShippingAddress = value.customer.shipping_addresses.at(-1);
    // setShippingInfo(value);
    setSelectedShippingInfo(lastShippingAddress);
  };

  useEffect(() => {
    setSelectedShippingInfo([]);
  }, [type]);

  useEffect(() => {

    setSelectAddress(selectedShippingInfo);
  }, [selectedShippingInfo]);

  useEffect(() => {
    let mounted = true;

    if (mounted && selectedShippingInfo) {
      setSelectAddress(selectedShippingInfo);
    }

    return () => {
      mounted = false;
    };
  }, [selectedShippingInfo, setSelectAddress]);


  useEffect(() => {
    let mounted = true;

    if (mounted && selectedShippingInfo) {
      setSelectAddress(selectedShippingInfo);
    }

    return () => {
      mounted = false;
    };
  }, [selectedShippingInfo, setSelectAddress]);

  useEffect(() => {

    if (shippingAddress && shippingAddress.length > 0) {
      // 기본배송지 찾기
      const defaultAddress = shippingAddress.find(
        address => address.metadata?.default === true
      );

      // 기본배송지가 있으면 설정, 없으면 첫 번째 주소 설정
      if (defaultAddress) {
        setSelectedShippingInfo(defaultAddress);
      } else {
        setSelectedShippingInfo(shippingAddress[0]);
      }

    }
  }, []);

  useEffect(() => {
    let mounted = true;

    if (mounted && inputs.current && inputs.current.length === 6 && type === "NEW") {
      const newAddress = {
        name: inputs.current[0]?.getValue() || "",
        first_name: inputs.current[1]?.getValue() || "",
        last_name: "",
        province: "",
        postal_code: inputs.current[2]?.getValue() || "",
        address_1: inputs.current[3]?.getValue() || "",
        address_2: inputs.current[4]?.getValue() || "",
        phone: inputs.current[5]?.getValue() || "",
        company: "default_company",
        city: "city",
        country_code: "kr",
      };

      setSelectAddress(newAddress);
    }

    return () => {
      mounted = false;
    };
  }, [
    type,
    setSelectAddress,
    inputs.current[0]?.getValue(),
    inputs.current[1]?.getValue(),
    inputs.current[2]?.getValue(),
    inputs.current[3]?.getValue(),
    inputs.current[4]?.getValue(),
    inputs.current[5]?.getValue(),
  ]);

  const WebLayout = () => (
    <FlexChild>
      <VerticalFlex gap={10}>
        <FlexChild>
          <Center width={"100%"} textAlign={"left"} padding={'0 0 15px 0'}>
            <P size={24} weight={"bold"}>
              {t("shippingInfoAdd")}
            </P>
          </Center>
          <div className={style.boldDivider} />
        </FlexChild>
        <FlexChild padding={"10px 0 0 0"}>
          <div className={style.newMobileAddressWrap}>
            <HorizontalFlex gap={10}>
              <FlexChild>
                {selectedShippingInfo?.address_1 ? (
                  <VerticalFlex flexStart gap={5}>
                    <FlexChild marginBottom={10} paddingTop={10}>
                      <HorizontalFlex justifyContent={"flex-start"}>
                        <FlexChild width={"fit-content"}>
                          <P size={20} weight={900}>
                            배송지명 : {selectedShippingInfo?.name}
                          </P>
                          <Dummy width={20} />
                        </FlexChild>
                        <FlexChild width={"max-content"} justifyContent={"flex-start"}>
                          <P
                            cursor
                            onClick={shippingInfoClick}
                            padding={"5px 12px"}
                            borderRadius={"3px"}
                            border={"1.5px solid #777"}
                            color={"#777"}
                            backgroundColor={"white"}
                            size={"12pt"}
                          >
                            {t("배송지 선택")}
                          </P>
                        </FlexChild>
                      </HorizontalFlex>
                    </FlexChild>
                    <FlexChild>
                      <P size={18}>
                        우편번호 : {selectedShippingInfo &&
                          selectedShippingInfo?.postal_code}
                      </P >
                    </FlexChild>
                    <FlexChild>
                      <P size={18}>
                        주소지 : {selectedShippingInfo &&
                          selectedShippingInfo?.address_1 +
                          " " +
                          selectedShippingInfo?.address_2}
                      </P>
                    </FlexChild>
                    <FlexChild>
                      <P size={18}>
                        전화번호 : {selectedShippingInfo?.phone}
                      </P>
                    </FlexChild>
                  </VerticalFlex>
                ) : (
                  <VerticalFlex flexStart gap={10}>
                    <FlexChild marginBottom={10}>
                      <P weight={'bold'} size={26}>배송지를 선택해주세요</P>
                    </FlexChild>
                    <FlexChild>
                      <P
                        cursor
                        onClick={onAddShippingInfoClick}
                        padding={"5px 12px"}
                        borderRadius={"3px"}
                        border={"1.5px solid var(--main-color)"}
                        color={"white"}
                        backgroundColor={"var(--main-color)"}
                        size={"12pt"}
                      >
                        + 배송지 추가
                      </P>
                    </FlexChild>
                  </VerticalFlex>
                )}
              </FlexChild>
              <FlexChild className={style.messageSection}>
                <MessageInput
                  value={selectedShippingInfo?.message || message}
                  // onChange={handleMessageChange}
                  onChange={onMessageChange}

                  placeHolder="배송 메세지를 입력하세요."
                  label={"배송 메세지"}
                />
              </FlexChild>
            </HorizontalFlex>
          </div>
        </FlexChild>
      </VerticalFlex >
    </FlexChild >
  );

  const MobileLayout = () => (
    <FlexChild>
      <VerticalFlex gap={10}>
        <FlexChild>
          <Center width={"100%"} textAlign={"left"} padding={'0 0 15px 0'}>
            <P size={24} weight={"bold"}>
              {t("shippingInfoAdd")}
            </P>
          </Center>
          <div className={style.boldDivider} />
        </FlexChild>
        <FlexChild padding={"10px 0 0 0"}>
          <div className={style.newMobileAddressWrap}>
            <VerticalFlex gap={10}>
              <FlexChild>
                <HorizontalFlex gap={25}>
                  <FlexChild>
                    <HorizontalFlex gap={20}>
                      <FlexChild width={"max-content"}>
                        <P weight={"bold"}>
                          {defaultShippingInfo &&
                            defaultShippingInfo.shippingName}
                        </P>
                      </FlexChild>
                      <FlexChild>
                      </FlexChild>
                    </HorizontalFlex>
                  </FlexChild>
                  <FlexChild justifyContent={"flex-end"}>
                    <P
                      cursor
                      onClick={shippingInfoClick}
                      padding={"1px 6px"}
                      borderRadius={"3px"}
                      border={"1.5px solid #999"}
                      color={"#999"}
                      backgroundColor={"white"}
                      size={"10pt"}
                    >
                      {t("shippingAddressList")}
                    </P>
                  </FlexChild>
                </HorizontalFlex>
              </FlexChild>
              <FlexChild>
                {selectedShippingInfo?.address_1 ? (
                  <VerticalFlex flexStart>
                    <FlexChild marginBottom={10}>
                      <P size={18} weight={'bold'}>
                        {selectedShippingInfo?.name}
                      </P>
                    </FlexChild>
                    <FlexChild>
                      <P>
                        {selectedShippingInfo &&
                          selectedShippingInfo?.postal_code}
                      </P>
                    </FlexChild>
                    <FlexChild>
                      <P>
                        {selectedShippingInfo &&
                          selectedShippingInfo?.address_1 +
                          " " +
                          selectedShippingInfo?.address_2}
                      </P>
                    </FlexChild>
                    <FlexChild>
                      <P>
                        {selectedShippingInfo?.phone}
                      </P>
                    </FlexChild>
                    <FlexChild padding={"10px 0"}>
                      <P
                        cursor
                        onClick={onAddShippingInfoClick}
                        weight={"bold"}
                        color={"var(--main-color)"}
                      >
                        + 배송지 추가
                      </P>
                    </FlexChild>
                  </VerticalFlex>
                ) : (
                  <VerticalFlex flexStart>
                    <FlexChild marginBottom={10}>
                      <P weight={'bold'} size={18}>배송지를 선택해주세요</P>
                    </FlexChild>
                    <FlexChild>
                      <P
                        cursor
                        onClick={onAddShippingInfoClick}
                        weight={"bold"}
                        color={"var(--main-color)"}
                      >
                        + 배송지 추가
                      </P>
                    </FlexChild>
                  </VerticalFlex>
                )}
              </FlexChild>
              <FlexChild>
                <MessageInput
                  // value={selectedShippingInfo?.message || message}
                  value={message}
                  // onChange={handleMessageChange}
                  onChange={onMessageChange}
                  placeHolder="배송 메세지를 입력하세요."
                  label={"배송 메세지"}
                />
              </FlexChild>
            </VerticalFlex>
          </div>
        </FlexChild>
      </VerticalFlex>
    </FlexChild>
  );

  return isMobile ? <MobileLayout /> : <WebLayout />;

});

NewShippingInfomation.displayName = 'NewShippingInfomation';
export default NewShippingInfomation;
